import { PlannerEndpoints } from '../planner/constants/planner-endpoints.const';
import { environment } from '../../environments/environment';

export const CacheEndPoints: string[] = [
    PlannerEndpoints.dspMarkets.replace(environment.ccpApiUrl, ''),
    PlannerEndpoints.dspAdvertisers.replace(environment.ccpApiUrl, '')
];